import { JSX } from 'react'
import { useParams } from 'react-router'

import { LuTvMinimal, LuUsers } from 'react-icons/lu'


import * as detective from '@/lib/detective.js'


import { Router } from '@/views/supervisor'

// eslint-disable-next-line @typescript-eslint/naming-convention
import * as Empty from '@/components/ui/empty.tsx'
// eslint-disable-next-line @typescript-eslint/naming-convention
import * as Tab from '@/components/ui/tab.tsx'

// eslint-disable-next-line @typescript-eslint/naming-convention
import * as Layout from '@/components/layout.tsx'


// eslint-disable-next-line @typescript-eslint/naming-convention
import Overview from '../overview'

// eslint-disable-next-line @typescript-eslint/naming-convention
import Contract from '../contract'




export enum Options {
	defalut = '总览',

	contract = '执行合同',

}

// eslint-disable-next-line @typescript-eslint/naming-convention
export function Tabs
(
	props: {
		_id: string

	},

)
:	JSX.Element
{
	let options: Tab.TOption[] = [
		{
			value: Options.defalut,
			label: Options.defalut,

			icon: <LuTvMinimal />,

			content: <Overview _id={props._id} />,

		},

		{
			value: Options.contract,
			label: Options.contract,

			icon: <LuUsers />,

			content: <Contract _id={props._id} />,

		},

	]

	return (
		<Tab.default default={Options.defalut} options={options} />

	)


}


export default function
(
	props: {
		deep: number

	},

)
:	JSX.Element
{
	let { [Router.archive]: _id } = useParams()

	return (
		<Layout.Main px="4" deep={props.deep}>
			{
				detective.is_required_string(_id)
					? <Tabs _id={_id} />
					: <Empty.Miss bg="white" shadow="sm" rounded="md" title="No ID" description="The archive ID is missing." />

			}

		</Layout.Main>

	)

}

